import styles from './ErrorsGraph.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import { ResponsivePieCanvas } from '@nivo/pie'
import Loader from '../../../miscellaneous/Loader/Loader'
import { FaChartPie } from 'react-icons/fa'

const ErrorsGraph = ({dateRange}) => {
    const { startDate, endDate } = dateRange;
    const [ data, setData ] = useState(null);
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            if (res.byErrorType) {
                const graphData = res.byErrorType.map((item) => {
                    return {
                        id: item.title,
                        label: item.title,
                        value: item.errors
                    }
                })
                setData(graphData)
            }
        }).catch(e => {
            console.error(e)
        })
    }, [dateRange])

    useEffect(() => {
        if(data !== null) {
            setIsLoaded(true)
        }
    }, [data])

    const getData = async () => {
        const data = await api.get(`service/errors?startDate=${startDate}&endDate=${endDate}`);
        return data.data.data;
    }

    return (<div className={styles.container}>
        {isLoaded ? <>
            {data.length ? <ResponsivePieCanvas
                data={ data }
                margin={ { top: 20, right: 0, bottom: 20, left: 0 } }
                innerRadius={ 0.6 }
                padAngle={ 0.7 }
                activeOuterRadiusOffset={ 8 }
                colors={[
                    '#93d5ed',
                    '#5c9ceb',
                    '#2e7de4',
                    '#1d5ba6',
                ]}
                borderColor="#000000"
                enableArcLinkLabels={ false }
                arcLinkLabelsSkipAngle={ 10 }
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={ 2 }
                arcLinkLabelsColor={ { from: 'color' } }
                arcLabelsSkipAngle={ 10 }
                arcLabelsTextColor="#333333"
            /> : <div className={`${ styles.noData }`}>
                <FaChartPie />
                No data
                </div>}
    </> : <div style={{margin: 'auto'}}><Loader color="#ddd"></Loader></div>}
    </div>)
}


export default ErrorsGraph;